export const roleTranslations = {
    owner: 'Владелец',
    admin: 'Администратор',
    editor: 'Редактор',
    member: 'Участник',
};
